import { type Dispatch, useEffect, useRef } from "react";
import { useUser } from "../requests/users";
import { warmAuthorizers, warmLambdas } from "../requests/warm";

const isWarmingRef = { current: false };

export const useWarm = (setIsWarm: Dispatch<boolean>) => {
  const user = useUser();
  const isUserDefined = user === undefined;
  const isWarming = useRef(isWarmingRef.current);

  useEffect(() => {
    if (isWarming.current) {
      return;
    }
    isWarming.current = true;
    isWarmingRef.current = true;

    const onDatabaseWarm = async () => {
      // Set to warm before awaiting the authorizers and lambdas so we do not block the homepage from loading.
      setIsWarm(true);
      if (user?.user_agreement_signed !== undefined) {
        try {
          void warmAuthorizers(user.permission_level_id);
          void warmLambdas();
        } catch (error) {
          console.error("Error warming up authorizers or lambdas:", error);
        }
      }
    };

    // const prefetchQueries = () => warmDatabase(onDatabaseWarm);

    // Clean up in finally() instead of by returning this in useEffect() to ensure that it completes first.
    // Otherwise, this could get triggered from many components and all run simultaneously.
    // prefetchQueries().finally(() => {
    onDatabaseWarm().finally(() => {
      isWarming.current = false;
      isWarmingRef.current = false;
    });
  }, [isUserDefined, setIsWarm, user?.permission_level_id, user?.user_agreement_signed]);
};
